import { Fragment } from "react";
import "./loader.scss";
import Loader from "react-loader-spinner";

const LoaderPopUp = () => {
  return (
    <Fragment>
      <section className="loader_pop_up_wrapper">
        <div className="loader_pop_up_inner_wrapper">
          <Loader type="TailSpin" color="#B50303" width={48} height={48} />
        </div>
      </section>
    </Fragment>
  );
};

export default LoaderPopUp;
